import { serviceGo } from '@/utils/request'

export interface GameAttribute {
  id?: number
  game_id: number
  role_id: number
  name: string
  initial_value: number
  created_at?: string
  updated_at?: string
}

export async function getGameAttributes(gameId: number): Promise<GameAttribute[]> {
  const resp = await serviceGo.get('/api_v2/game_attributes', {
    params: { game_id: gameId }
  })
  return resp.data.data || []
}

export async function createGameAttribute(data: GameAttribute): Promise<GameAttribute> {
  const resp = await serviceGo.post('/api_v2/game_attributes', data)
  return resp.data.data
}

export async function updateGameAttribute(id: number, data: Partial<GameAttribute>): Promise<void> {
  await serviceGo.put(`/api_v2/game_attributes/${id}`, data)
}

export async function deleteGameAttribute(id: number): Promise<void> {
  await serviceGo.delete(`/api_v2/game_attributes/${id}`)
}
